<div class="modal-overlay" *ngIf="isOpen" (click)="onClose()">
  <div class="modal-container" (click)="$event.stopPropagation()">
    <!-- Modal Header -->
    <div class="modal-header">
      <div class="header-content">
        <h2 class="modal-title">Campaign Preview</h2>
        <button class="close-button" (click)="onClose()">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 3L3 9M3 3L9 9" stroke="#555963" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>
    </div>

    <!-- Modal Content -->
    <div class="modal-content">
      <div class="content-grid">
        <!-- Overview Section -->
        <div class="section-card">
          <div class="section-header">
            <h3 class="section-title">Overview</h3>
            <button class="edit-button" (click)="navigateToBasicInfo()">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5.82812 5.83342H4.99479C4.55276 5.83342 4.12884 6.00902 3.81628 6.32158C3.50372 6.63414 3.32813 7.05806 3.32812 7.50009V15.0001C3.32813 15.4421 3.50372 15.866 3.81628 16.1786C4.12884 16.4912 4.55276 16.6668 4.99479 16.6668H12.4948C12.9368 16.6668 13.3607 16.4912 13.6733 16.1786C13.9859 15.866 14.1615 15.4421 14.1615 15.0001V14.1668M13.3281 4.16676L15.8281 6.66676M16.9823 5.48759C17.3105 5.15938 17.4949 4.71424 17.4949 4.25009C17.4949 3.78594 17.3105 3.34079 16.9823 3.01259C16.6541 2.68438 16.2089 2.5 15.7448 2.5C15.2806 2.5 14.8355 2.68438 14.5073 3.01259L7.49479 10.0001V12.5001H9.99479L16.9823 5.48759Z" stroke="#1B5BFF" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                
            </button>
          </div>
          <div class="section-content">
            <div class="info-row">
              <div class="info-label">Campaign Name</div>
              <div class="info-value">{{ getCampaignName() }}</div>
            </div>
            <div class="info-row">
              <div class="info-label">Description</div>
              <div class="info-value">{{ getCampaignDescription() }}</div>
            </div>
            <div class="info-row">
              <div class="info-label">Platform</div>
              <div class="info-value">{{ getPlatforms() }}</div>
            </div>
            <div class="info-row" *ngIf="showUserSegmentSection">
              <div class="info-label">User Segment</div>
              <div class="info-value">{{ getUserSegments() }}</div>
            </div>
            <div class="info-row">
              <div class="info-label">Location</div>
              <div class="info-value">{{ getLocations() }}</div>
            </div>
          </div>
        </div>

        <!-- Offers Section -->
        <div class="section-card">
          <div class="section-header">
            <h3 class="section-title">Offers</h3>
            <button class="edit-button" (click)="navigateToOfferOverview()">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5.82812 5.83342H4.99479C4.55276 5.83342 4.12884 6.00902 3.81628 6.32158C3.50372 6.63414 3.32813 7.05806 3.32812 7.50009V15.0001C3.32813 15.4421 3.50372 15.866 3.81628 16.1786C4.12884 16.4912 4.55276 16.6668 4.99479 16.6668H12.4948C12.9368 16.6668 13.3607 16.4912 13.6733 16.1786C13.9859 15.866 14.1615 15.4421 14.1615 15.0001V14.1668M13.3281 4.16676L15.8281 6.66676M16.9823 5.48759C17.3105 5.15938 17.4949 4.71424 17.4949 4.25009C17.4949 3.78594 17.3105 3.34079 16.9823 3.01259C16.6541 2.68438 16.2089 2.5 15.7448 2.5C15.2806 2.5 14.8355 2.68438 14.5073 3.01259L7.49479 10.0001V12.5001H9.99479L16.9823 5.48759Z" stroke="#1B5BFF" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                
            </button>
          </div>
          <div class="section-content">
            <div class="info-row">
              <div class="info-label">Offer Name</div>
              <div class="info-value">{{ getOfferName() }}</div>
            </div>
            <div class="info-row">
              <div class="info-label">Promo Code</div>
              <div class="info-value">{{ getPromoCode() }}</div>
            </div>
            <div class="info-row">
              <div class="info-label">Offer Description</div>
              <div class="info-value">{{ getOfferDescription() }}</div>
            </div>
            <div class="info-row">
              <div class="info-label">Offer Type</div>
              <div class="info-value">{{ getOfferType() }}</div>
            </div>
            <div class="info-row">
              <div class="info-label">Discount Value</div>
              <div class="info-value">{{ getDiscountValue() }}</div>
            </div>
            <div class="info-row">
              <div class="info-label">Car Wash Type</div>
              <div class="info-value">{{ getCarWashType() }}</div>
            </div>
            <div class="info-row">
              <div class="info-label">Location</div>
              <div class="info-value">{{ getLocation() }}</div>
            </div>
            <div class="info-row">
              <div class="info-label">Maximum Discount Amount</div>
              <div class="info-value">{{ getMaxDiscountAmount() }}</div>
            </div>
            <div class="info-row">
              <div class="info-label">Quantity Limit</div>
              <div class="info-value">{{ getQuantityLimit() }}</div>
            </div>
          </div>
        </div>

        <!-- Content Section -->
        <div class="section-card">
          <div class="section-header">
            <h3 class="section-title">Content</h3>
            <button class="edit-button" (click)="navigateToEmail()">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5.82812 5.83342H4.99479C4.55276 5.83342 4.12884 6.00902 3.81628 6.32158C3.50372 6.63414 3.32813 7.05806 3.32812 7.50009V15.0001C3.32813 15.4421 3.50372 15.866 3.81628 16.1786C4.12884 16.4912 4.55276 16.6668 4.99479 16.6668H12.4948C12.9368 16.6668 13.3607 16.4912 13.6733 16.1786C13.9859 15.866 14.1615 15.4421 14.1615 15.0001V14.1668M13.3281 4.16676L15.8281 6.66676M16.9823 5.48759C17.3105 5.15938 17.4949 4.71424 17.4949 4.25009C17.4949 3.78594 17.3105 3.34079 16.9823 3.01259C16.6541 2.68438 16.2089 2.5 15.7448 2.5C15.2806 2.5 14.8355 2.68438 14.5073 3.01259L7.49479 10.0001V12.5001H9.99479L16.9823 5.48759Z" stroke="#1B5BFF" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                
                
            </button>
          </div>
          <div class="section-content">
            <div class="info-row" *ngIf="isPlatformSelected('email')">
              <div class="info-label">Email</div>
              <div class="info-value" *ngIf="hasContent('email')">
                <span>Preview</span>
                <button class="preview-button" (click)="navigateToEmail()">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5.82812 5.83342H4.99479C4.55276 5.83342 4.12884 6.00902 3.81628 6.32158C3.50372 6.63414 3.32813 7.05806 3.32812 7.50009V15.0001C3.32813 15.4421 3.50372 15.866 3.81628 16.1786C4.12884 16.4912 4.55276 16.6668 4.99479 16.6668H12.4948C12.9368 16.6668 13.3607 16.4912 13.6733 16.1786C13.9859 15.866 14.1615 15.4421 14.1615 15.0001V14.1668M13.3281 4.16676L15.8281 6.66676M16.9823 5.48759C17.3105 5.15938 17.4949 4.71424 17.4949 4.25009C17.4949 3.78594 17.3105 3.34079 16.9823 3.01259C16.6541 2.68438 16.2089 2.5 15.7448 2.5C15.2806 2.5 14.8355 2.68438 14.5073 3.01259L7.49479 10.0001V12.5001H9.99479L16.9823 5.48759Z" stroke="#1B5BFF" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    
                </button>
              </div>
            </div>
            <div class="info-row" *ngIf="isPlatformSelected('sms')">
              <div class="info-label">Text Messaging</div>
              <div class="info-value" *ngIf="hasContent('sms')">
                <span>Preview</span>
                <button class="preview-button" (click)="navigateToTextMessage()">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5.82812 5.83342H4.99479C4.55276 5.83342 4.12884 6.00902 3.81628 6.32158C3.50372 6.63414 3.32813 7.05806 3.32812 7.50009V15.0001C3.32813 15.4421 3.50372 15.866 3.81628 16.1786C4.12884 16.4912 4.55276 16.6668 4.99479 16.6668H12.4948C12.9368 16.6668 13.3607 16.4912 13.6733 16.1786C13.9859 15.866 14.1615 15.4421 14.1615 15.0001V14.1668M13.3281 4.16676L15.8281 6.66676M16.9823 5.48759C17.3105 5.15938 17.4949 4.71424 17.4949 4.25009C17.4949 3.78594 17.3105 3.34079 16.9823 3.01259C16.6541 2.68438 16.2089 2.5 15.7448 2.5C15.2806 2.5 14.8355 2.68438 14.5073 3.01259L7.49479 10.0001V12.5001H9.99479L16.9823 5.48759Z" stroke="#1B5BFF" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    
                </button>
              </div>
            </div>
            <div class="info-row" *ngIf="isPlatformSelected('facebook')">
              <div class="info-label">Facebook Ads</div>
              <div class="info-value" *ngIf="hasContent('facebook')">
                <span>Preview</span>
                <button class="preview-button" (click)="navigateToFacebook()">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5.82812 5.83342H4.99479C4.55276 5.83342 4.12884 6.00902 3.81628 6.32158C3.50372 6.63414 3.32813 7.05806 3.32812 7.50009V15.0001C3.32813 15.4421 3.50372 15.866 3.81628 16.1786C4.12884 16.4912 4.55276 16.6668 4.99479 16.6668H12.4948C12.9368 16.6668 13.3607 16.4912 13.6733 16.1786C13.9859 15.866 14.1615 15.4421 14.1615 15.0001V14.1668M13.3281 4.16676L15.8281 6.66676M16.9823 5.48759C17.3105 5.15938 17.4949 4.71424 17.4949 4.25009C17.4949 3.78594 17.3105 3.34079 16.9823 3.01259C16.6541 2.68438 16.2089 2.5 15.7448 2.5C15.2806 2.5 14.8355 2.68438 14.5073 3.01259L7.49479 10.0001V12.5001H9.99479L16.9823 5.48759Z" stroke="#1B5BFF" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    
                </button>
              </div>
            </div>
            <div class="info-row" *ngIf="isPlatformSelected('google')">
              <div class="info-label">Google Ads</div>
              <div class="info-value" *ngIf="hasContent('google_ads')">
                <span>Preview</span>
                <button class="preview-button" (click)="navigateToGoogleAds()">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5.82812 5.83342H4.99479C4.55276 5.83342 4.12884 6.00902 3.81628 6.32158C3.50372 6.63414 3.32813 7.05806 3.32812 7.50009V15.0001C3.32813 15.4421 3.50372 15.866 3.81628 16.1786C4.12884 16.4912 4.55276 16.6668 4.99479 16.6668H12.4948C12.9368 16.6668 13.3607 16.4912 13.6733 16.1786C13.9859 15.866 14.1615 15.4421 14.1615 15.0001V14.1668M13.3281 4.16676L15.8281 6.66676M16.9823 5.48759C17.3105 5.15938 17.4949 4.71424 17.4949 4.25009C17.4949 3.78594 17.3105 3.34079 16.9823 3.01259C16.6541 2.68438 16.2089 2.5 15.7448 2.5C15.2806 2.5 14.8355 2.68438 14.5073 3.01259L7.49479 10.0001V12.5001H9.99479L16.9823 5.48759Z" stroke="#1B5BFF" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Goals Section -->
        <div class="section-card" *ngIf="getFirstGoal()">
          
          <div class="section-content">
            <div *ngIf="getGoals().length === 0" class="info-row">
              <div class="info-value">No goals defined</div>
            </div>
            <div *ngFor="let goal of getGoals(); let i = index; trackBy: trackByIndex" class="section-content">
              <div class="section-header" >
                <h4 class="section-title">Goal {{ i + 1 }}</h4>
              </div>
              <div class="info-row">
                <div class="info-label">Goal Name</div>
                <div class="info-value">{{ goal?.goal_name || 'No goal name' }}</div>
              </div>
              <div class="info-row">
                <div class="info-label">Event</div>
                <div class="info-value">{{ getEventLabel(goal) }}</div>
              </div>
              <div class="info-row">
                <div class="info-label">Target Value</div>
                <div class="info-value">{{ goal?.target_value || 'No target value' }}</div>
              </div>
              <div class="info-row">
                <div class="info-label">Timeframe</div>
                <div class="info-value">{{ getTimeframeLabel(goal) }}</div>
              </div>
            </div>
          </div>
        </div>

        <!-- Schedule Section -->
        <div class="section-card">
          <div class="section-header">
            <h3 class="section-title">Schedule</h3>
            <button class="edit-button" (click)="navigateToSchedule()">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5.82812 5.83342H4.99479C4.55276 5.83342 4.12884 6.00902 3.81628 6.32158C3.50372 6.63414 3.32813 7.05806 3.32812 7.50009V15.0001C3.32813 15.4421 3.50372 15.866 3.81628 16.1786C4.12884 16.4912 4.55276 16.6668 4.99479 16.6668H12.4948C12.9368 16.6668 13.3607 16.4912 13.6733 16.1786C13.9859 15.866 14.1615 15.4421 14.1615 15.0001V14.1668M13.3281 4.16676L15.8281 6.66676M16.9823 5.48759C17.3105 5.15938 17.4949 4.71424 17.4949 4.25009C17.4949 3.78594 17.3105 3.34079 16.9823 3.01259C16.6541 2.68438 16.2089 2.5 15.7448 2.5C15.2806 2.5 14.8355 2.68438 14.5073 3.01259L7.49479 10.0001V12.5001H9.99479L16.9823 5.48759Z" stroke="#1B5BFF" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                
            </button>
          </div>
          <div class="section-content">
            <div class="info-row">
              <div class="info-label">Start Date</div>
              <div class="info-value">{{ getStartDate() }}</div>
            </div>
            <div class="info-row">
              <div class="info-label">Start Time</div>
              <div class="info-value">{{ getStartTime() }}</div>
            </div>
            <div class="info-row">
              <div class="info-label">Recurring Frequency</div>
              <div class="info-value">{{ getRecurringFrequency() }}</div>
            </div>
            <div class="info-row">
              <div class="info-label">End Date</div>
              <div class="info-value">{{ getEndDate() }}</div>
            </div>
            <div class="info-row">
              <div class="info-label">End Time</div>
              <div class="info-value">{{ getEndTime() }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Footer -->
    <div class="modal-footer">
      <button class="btn btn-secondary" (click)="onClose()">Close</button>
      <button 
        class="btn btn-primary" 
        (click)="onConfirmAndPublish()" 
        [disabled]="!isAllSectionsCompleted() || isPublishing">
        <span *ngIf="isPublishing" class="loading-spinner">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" class="spinner">
            <circle cx="8" cy="8" r="6" stroke="currentColor" stroke-width="2" fill="none" stroke-dasharray="31.416" stroke-dashoffset="31.416">
              <animate attributeName="stroke-dasharray" dur="2s" values="0 31.416;15.708 15.708;0 31.416" repeatCount="indefinite"/>
              <animate attributeName="stroke-dashoffset" dur="2s" values="0;-15.708;-31.416" repeatCount="indefinite"/>
            </circle>
          </svg>
          Publishing...
        </span>
        <span *ngIf="!isPublishing">Confirm & Publish</span>
      </button>
    </div>
  </div>
</div>
